import { FinancialData } from './financial-data';

export class FinancialDataPayload {
  financialData: FinancialData[] = [];
  valueEnteredIn: number;
}
